var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["IntroText.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["introText"], 
[], 
function (l_introText, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("introText", l_introText);
var t_2 = "";t_2 += "<div class=\"IntroText\">\n        <div class=\"IntroText-col IntroText-col--summary\">\n            <div class=\"IntroText-summary\">\n                ";
if(runtime.memberLookup((l_introText),"authors")) {
t_2 += "\n                    ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"authors")), env.opts.autoescape);
t_2 += "\n                ";
;
}
t_2 += "\n\n                ";
if(runtime.memberLookup((l_introText),"notes")) {
t_2 += "\n                    ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"notes")), env.opts.autoescape);
t_2 += "\n                ";
;
}
t_2 += "\n            </div>\n        </div>\n        <div class=\"IntroText-col IntroText-col--text\">\n            ";
if(runtime.memberLookup((l_introText),"text")) {
t_2 += "\n                <div class=\"IntroText-text\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"text")), env.opts.autoescape);
t_2 += "</div>\n\n                ";
if(runtime.memberLookup((l_introText),"textExtended")) {
t_2 += "\n                    <div class=\"IntroText-more\">";
t_2 += runtime.suppressValue((lineno = 18, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Узнать больше"])), env.opts.autoescape);
t_2 += "</div>\n                    <div class=\"IntroText-moreText IntroText-text\" style=\"display: none\">\n                        <div class=\"IntroText-moreTextInner\">\n                            ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"textExtended")), env.opts.autoescape);
t_2 += "\n                        </div>\n                        <div class=\"IntroText-less\">";
t_2 += runtime.suppressValue((lineno = 23, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Скрыть текст"])), env.opts.autoescape);
t_2 += "</div>\n                    </div>\n                ";
;
}
t_2 += "\n            ";
;
}
t_2 += "\n        </div>\n    </div>";
t_2 += runtime.suppressValue((lineno = 28, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("IntroText");
context.setVariable("IntroText", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["IntroText.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IntroText/IntroText.jinja
// module id = 72
// module chunks = 0